import moment from 'moment';
import { browserTimeZone } from 'utils/time';

export const scheduleDisplay = (value) => value
  ? moment(value).format('MM/DD/YYYY h:mm A [UTC]Z') : 'Not set';

export const legacyBoundary = (date, end = false) => date
  ? `${date}T${end ? '23:59:59' : '00:00:00'}Z` : undefined;

// Form values without an offset are local wall times, including older offline drafts.
export const scheduleInstant = (value) => value ? moment(value).toISOString() : undefined;

export const scheduleToApi = (budget) => {
  if (!budget) return undefined;
  return {
    startAt: scheduleInstant(budget.startDate),
    endAt: scheduleInstant(budget.endDate),
    timeZone: budget.timeZone || browserTimeZone(),
  };
};

// The date adapter can normalize nonexistent spring-forward times. Reject them
// using the user's wall-clock input before accepting that normalized value.
export const isMissingLocalTime = (text) => {
  const cleaned = (text || '').replace(/[\u200e\u200f\u2066-\u2069]/g, '').trim();
  if (!/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2} [AP]M$/i.test(cleaned)) return false;
  const value = moment(cleaned, 'MM/DD/YYYY hh:mm A', true);
  return value.isValid() && value.format('MM/DD/YYYY hh:mm A') !== cleaned.toUpperCase();
};
